import { districtBelongsToCity } from './locationOptions';
import React, { useState,useEffect } from 'react'
import { Edit, useRedirect } from 'react-admin'
import {
  Box, Typography, TextField, Button, Grid, TableContainer, Table, TableHead,
  TableBody, TableRow, Paper, Select, MenuItem, Switch, InputLabel, Tab, Tabs, Modal,Snackbar, Alert,Pagination,OutlinedInput,FormControl,FormHelperText
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import globalStyles from '../../utils/globalStyles'
import dataProvider from '../../utils/dataProvider'
import UpdateForm from '../customer/CreateUser'
import AddressList from './AddressList'
import axios from 'axios'
import generateToken from '../../utils/generateToken'
import globalConfig from '../../utils/globalConfig'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useParams } from 'react-router-dom'
import legolasApi from '../../api/legolas'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { useLocation,useNavigate } from 'react-router-dom'
import EditIcon from '@mui/icons-material/Edit';
import { remove, isArray, isEmpty } from 'lodash';
import elrondApi from '../../api/elrond'
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DocumentPreview from "../common/DocumentPreview";



const addressLocationRowStyles = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  width: '100%',
  alignItems: 'flex-start',
  my: 2,
};
const addressLocationLabelStyles = {
  width: { xs: '100%', sm: '20%' },
  pt: { xs: 0, sm: 2 },
  mb: { xs: 1, sm: 0 },
};
const addressLocationInputStyles = {
  width: { xs: '100%', sm: '50%' },
  minWidth: 0,
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));




const AccountInformation = (props) => {
  const { created_in, created_at, group_id, updated_at, channel } = props
  
  const darkBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }

  const errormessage ={
    color:'red',
    fontWeight:'bold'
  }
  const controllerFields = {
    margin: '10px 30%',
    width: '500px',
    // borderBottom: '2px solid #2b3f7a',
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: '#fff !important'
    }
  }

  return (
    <React.Fragment>
      <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
        <Typography variant='h6'>Personal Information</Typography>
      </Box>
      
    
      <Grid container spacing={5} columns={24}>
        <Grid item xs={12}>
          <Box sx={darkBox}>
            <Typography>Last Logged in:</Typography>
            <Typography>{checkUpdatedDate(updated_at) == 1 ? 'Today' : checkUpdatedDate(updated_at)}</Typography>
          </Box>
          <Box sx={lightBox}>
            <Typography>Account Lock:</Typography>
            <Typography>Unlocked</Typography>
          </Box>
          <Box sx={darkBox}>
            <Typography>Confirmed email:</Typography>
            <Typography>Confirmation Not Required</Typography>
          </Box>
          <Box sx={lightBox}>
            <Typography>Account Created:</Typography>
            <Typography>{formatDateAndTime(new Date(created_at))}</Typography>
          </Box>
          <Box sx={darkBox}>
            <Typography>Account Created in:</Typography>
            {
              typeof created_in == 'string' &&
              <Typography>{created_in.includes('English') ? 'English' : 'Arabic'}</Typography>
            }
          </Box>
          <Box sx={lightBox}>
            {/* <Typography>Customer Group:</Typography>
            <Typography>{globalConfig.customerGroups[group_id]}</Typography> */}
          </Box>
          <Box sx={darkBox}>
            <Typography>Channel:</Typography>
            {
              channel ? 
              <Typography>{channel}</Typography> : null
            }
          </Box>
        </Grid>
        <Grid item xs={12}>
        </Grid>
      </Grid>
    </React.Fragment>

  )
}

const checkUpdatedDate = (inputDate) => {
  let today = new Date()
  let updateDate = new Date(inputDate)
  let isToday = (today.toDateString() == updateDate.toDateString())
  if (isToday) {
    return 1
  } else {
    return formatDateAndTime(updateDate)
  }
}

const formatDateAndTime = (inpDate) => {
  let retDate = ''
  const month = inpDate.toLocaleDateString('default', { month: 'short' })
  const date = inpDate.getDate()
  const year = inpDate.getFullYear()
  const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
  return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

function EditUser(props) {
  //const { state: { data } } = useLocation()
  const location = useLocation();
const data = location?.state?.data || null;
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0)
  const [value, setNavigationValue] = React.useState(0);
  const [tabValue, setTabValue] = React.useState(0)
  const [menuContent, setMenuContent] = React.useState(null)
  const [user, setUser] = React.useState(null)
  const [customerModal, setcustomerModal] = React.useState(false);
  const [resetModal,setresetModal] = React.useState(false);
  const handleClose = () => setcustomerModal(false);
  const handleCloseReset = () => setresetModal(false);
  const handleCloseEdit = () => setEditModal(false);
  const [action, setAction] = React.useState("");
  const [listData, setListData] = React.useState([]);
  const [cartItem,setcartItem] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [orderItem, setorderItem] = React.useState([]);
  const [totalCount, setTotalcount] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const[resetOpen,setResetOpen] = React.useState(false);
  const [EditModal,setEditModal] = React.useState(false); 
  const [EditOpen,setEditOpen] = React.useState(false);
  const [message,setMessage] = React.useState(false);
  const [countryList, setCountryList] = React.useState([])
  const [districtList, setDistrictList] = React.useState([])
  const [cityList, setCityList] = React.useState([])
  const [countryCode, setCountryCode] = React.useState('')
  const [cityCode, setCityCode] = React.useState('')
  const [districtCode, setDistrictCode] = React.useState('')
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [countryPhoneExt, setCountryPhoneExt] = useState('+966');
  const [phonePH, setPhonePH] = useState("Enter phone number");
  const [otherCity, setOtherCity] = useState('');
  const [otherDistrict, setOtherDistrict] = useState('');
  const [remarksString, setRemarksString] = React.useState('')
  const [focus, setFocus] = React.useState(false);
  const [countryExtCodes, setCountryExtCodes] = useState([
    { code: 'SA', text: '+966', length: 9, start: ['5'], emoji: "🇸🇦", flag: '/static/content/flag-saudi.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00966|966|\\+966)', pHolder: '5X XXX XXXX' },
    { code: 'AE', text: '+971', length: 9, start: ['5'], emoji: "🇦🇪", flag: '/static/content/flag-uae.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00971|971|\\+971)', pHolder: '5X XXX XXXX' },
    { code: 'BH', text: '+973', length: 8, start: ['3'], emoji: "🇧🇭", flag: '/static/content/flag-baharain.png', regEx: '^(3)[0-9]{7}$', repExp: '^(00973|973|\\+973)', pHolder: '3X XXX XXX' },
    { code: 'OM', text: '+968', length: 8, start: ['7', '9'], emoji: "🇴🇲", flag: '/static/content/flag-oman.png', regEx: '^(7|9)[0-9]{7}$', repExp: '^(00968|968|\\+968)', pHolder: '7X XXX XXX' },
    { code: 'KW', text: '+965', length: 8, start: ['9'], emoji: "🇰🇼", flag: '/static/content/flag-kuwait.png', regEx: '^(9)[0-9]{7}$', repExp: '^(00965|965|\\+965)', pHolder: '9X XXX XXX' },
    { code: 'QA', text: '+974', length: 8, start: ['3', '5', '9'], emoji: "", flag: '/static/content/flag-qatar.png', regEx: '^(3|5|9)[0-9]{7}$', repExp: '^(00974|974|\\+974)', pHolder: '3X XXX XXX' },
  ]);
  const [pendingFormData, setPendingFormData] = React.useState({});
  const rawPostcode = pendingFormData.postcode?.toString().trim() || "";
  const [idDocs, setIdDocs] = useState([]);
  const [addressDocs, setAddressDocs] = useState([]);
  const [idDocsPreview, setIdDocsPreview] = useState([]);
  const [addressDocsPreview, setAddressDocsPreview] = useState([]);
  const [idDocsRaw, setIdDocsRaw] = useState([]);
  const [addressDocsRaw, setAddressDocsRaw] = useState([]);
  const [citySearchEdit, setCitySearchEdit] = React.useState("");
  const [districtSearchEdit, setDistrictSearchEdit] = React.useState("");
  const [processingUsers, setProcessingUsers] = useState({});

  const media_cdn = process.env.REACT_APP_MEDIA_CDN_PATH;

  function isValidSaudiVAT(vat) {
    if (!vat) return false;

    vat = vat.replace(/\D/g, '');

    return /^3\d{12}03$/.test(vat);
  }

  useEffect(() => {
    if (!user || !media_cdn) return;

    const parsedId = parseDocs(user.idProofDocument);
    const parsedAddress = parseDocs(user.addressProofDocument);

    setIdDocs(parsedId);
    setAddressDocs(parsedAddress);

    // 🔑 sync preview ONLY on initial user load
    setIdDocsPreview(parsedId);
    setAddressDocsPreview(parsedAddress);
  }, [user, media_cdn]);

  useEffect(() => {
    if (!user) return;

    const parseRaw = (val) => {
      if (Array.isArray(val)) return val;
      try {
        const parsed = JSON.parse(val || "[]");
        return Array.isArray(parsed) ? parsed : [];
      } catch { return []; }
    };

    const idRaw = parseRaw(user.idProofDocument);
    const addrRaw = parseRaw(user.addressProofDocument);

    setIdDocsRaw(idRaw);
    setAddressDocsRaw(addrRaw);

    // 🔑 form payload SAME rahe
    setValue("idProofDocument", idRaw);
    setValue("addressProofDocument", addrRaw);
  }, [user]);

  const toPreviewUrls = (list = []) =>
    list
      .map((p) => {
        if (!p) return null;

        // ✅ object case
        if (typeof p === "object") {
          return p.path || p.url || null;
        }

        // ✅ string case
        if (typeof p === "string") {
          return p.trim();
        }

        return null;
      })
      .filter(Boolean)
      .map((p) =>
        p.startsWith("http")
          ? p
          : `${process.env.REACT_APP_MEDIA_CDN_PATH}/${p.replace(/^\/+/, "")}`
      );





  const validatePhoneNumber = (value) => {
    // Find the selected country's configuration
    const selectedCountry = countryExtCodes.find(
      (country) => country.text === countryPhoneExt
    );
  
    if (!selectedCountry) {
      return "Invalid country selection.";
    }
  
    if (!value || value.length === 0) {
      return "Phone number is required.";
    }
  
    // Check if the phone number matches the selected country's pattern
    if (!selectedCountry) return showError("Please select a valid country.", "country_id");
    const phoneRegex = new RegExp(selectedCountry.regEx);
    if (!phoneRegex.test(value)) {
      return `Invalid phone number format. Expected: ${selectedCountry.pHolder}`;
    }
  
    return true; // Validation passed
  };
  
  const handlePhoneInput = (e, onChange) => {
    const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
  
    const selectedCountry = countryExtCodes.find(
      (country) => country.text === countryPhoneExt
    );
  
    if (selectedCountry) {
      // Limit the input to the maximum length for the selected country
      const trimmedValue = inputValue.slice(0, selectedCountry.length);
      onChange(trimmedValue); // Update the value
    } else {
      onChange(inputValue); // Default behavior for no selected country
    }
  };


  const handleCountry = (code) => {
    setCountryCode(code);
    const foundCountry = countryList.find(country => country.code === code);
    setCityList(sortAZ(foundCountry?.cities || []));
    setDistrictList(sortAZ(foundCountry?.districts || []));
    setCitySearchEdit("");
    setDistrictSearchEdit("");
    setCityCode("");
    setDistrictCode("");
    setOtherCity("");
    setOtherDistrict("");
    setAddressData(prev => ({ ...prev, country_code: code, city_id: "", district_id: "",
      city: "", district: "", other_city: "", other_district: "" }));
    const countryExt = countryExtCodes.find(ext => ext.code === code);
    if (countryExt) {
      setCountryPhoneExt(countryExt.text);
      setPhonePH(countryExt.pHolder);
    }
    reset({
      ...getValues(),
      country_code: code,
      ...(countryExt ? { phone_ext: countryExt.text, telephone: "" } : {}),
      city_id: "", district_id: "", other_city: "", other_district: "",
      street: "", building_no: "", customer_unique_id: "",
    });
  };

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }
  const closeAlert = () => {
    setOpenAlert(false)
  }

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setCityCode(selectedCity);
    if ( isSaudi && selectedCity !== 'Others') {
      setOtherCity('');
    }
          setValue("other_city", ""); 

    reset({
      ...getValues(),
      street: "",
      city_id: selectedCity,
      district_id: "",
      other_district: "",
    });
    setDistrictCode("");
    setOtherDistrict("");
    setDistrictSearchEdit("");
    setAddressData(prev => ({ ...prev, city_id: selectedCity, district_id: "", district: "", other_district: "" }));
  };

  const handleDistrictChange = (e) => {
    const selectedDistrict = e.target.value;
    setDistrictCode(selectedDistrict);
    if ( isSaudi && selectedDistrict !== 'Others') {
      setOtherDistrict('');
    }
    reset({
      ...getValues(),
      street: "",
      district_id: selectedDistrict,
    });
  };

    const [currentGroup, setCurrentGroup] = React.useState(1);

  const { group_id } = props
  const [defaultCountryList, setDefaultCountryList] = React.useState([]);
  const [dobValue, setDobValue] = React.useState(dayjs(new Date()))

 const handleDateChange = (newVal) => {
    setDobValue(newVal)
  }
   const [addressData, setAddressData] = React.useState({
    customer_firstname: "",
    customer_lastname: "",
    street: "",
    country: "Saudi Arabia",
    country_id: 1,
    country_code: "SA",
    city_id: "",
    city: "",
    district_id: "",
    district: "",
    postcode: "",
    phone_ext: "",
    phone: "",
    building_no: "",
    customer_unique_id: "",

  });

  
  const [generalCountries, setGeneralCountries] = React.useState([]);
  const [generalCitySearch, setGeneralCitySearch] = React.useState("");
  const [generalDistrictSearch, setGeneralDistrictSearch] = React.useState("");

  const [userFormvals, setUserFormVals] = React.useState({
    'firstname': "",
    'lastname': "",
    'mobile_number': "",
    'gender' : "",
    'created_in' :"",
    "dob" :"",
  });

  
  console.log("userform value", userFormvals.mobile_number);
  // const handleChangeform = (event) =>{
  // const {name,value} = event.target
  // // debugger
  //   console.log("name",name, "value:", value);
  //   setUserFormVals({...userFormvals,[name] :value});
  //   //console.log("userform value", userFormvals);
  // }
  const [resetFormvals, setResetFormVals] = React.useState({  
    'newpassword': "",
    'confrmpassword': "",
    
  });
 
  
  const params = useParams()
  const { id } = useParams();

  const sortAZ = (list = []) => {
    if (!Array.isArray(list)) return [];
    return [...list].sort((a, b) => {
      const aText = a.value || a.name || a.label || "";
      const bText = b.value || b.name || b.label || "";
      return aText.localeCompare(bText, undefined, { sensitivity: "base" });
    });
  };


   React.useEffect(() => {
  const fetchUserAndLocation = async () => {
    try {
      const data = { user_id: id };
      const signedToken = generateToken(data);
      

      // Call both APIs in parallel
      const [userRes, locationRes] = await Promise.all([
        axios.get(`${legolasApi.url}/admin/user/solo`, {
          headers: {
            Authorization: `Bearer ${signedToken}`,
            "Content-Type": "application/json",
          },
        }),
        axios.get(`${elrondApi.url}/hnak/locationdata/${elrondApi.source}`),
      ]);

      if (!userRes.data.success) {
        console.error("Failed to fetch user");
        return;
      }

        const u = userRes.data.data;
        setGeneralCountries(sortAZ(locationRes.data.data || []));
        let foundCountry = null;
        if (u.country_id && (u.group_id || 1) !== 1) {
          console.log('new user data', u)
          const defaultCountryCode = u.country_id;
          const defaultCountryList = locationRes.data.data || [];
          setCountryList(sortAZ(defaultCountryList));
          console.log('default country code', defaultCountryCode, defaultCountryList);

      const foundCountry =
        defaultCountryList.find(
          (country) => country.id == defaultCountryCode
        );
        console.log('found country',foundCountry)
      if (!foundCountry) {
        console.warn("Country not found:", defaultCountryCode);
        return;
      }

          setCountryCode(foundCountry.code);
          setValue("country_code", foundCountry.code);
          setValue(
            "customer_unique_id",
            u.customer_unique_id || "",
            {
              shouldValidate: false,
              shouldDirty: false,
            }
          );
          setCityList(sortAZ(foundCountry.cities || []));
          setDistrictList(sortAZ(foundCountry.districts || []));

      const countryExt = countryExtCodes.find(
        (ext) => ext.code === foundCountry.code
      );
      if (countryExt) {
        setCountryPhoneExt(countryExt.text);
        setPhonePH(countryExt.pHolder);
        setValue("phone_ext", countryExt.text);
        setValue("telephone", props.address?.telephone || "");
      }
      }
      // --- Process location data ---     

        // --- Process user data ---

        setUser(u);
        setValue( "customer_unique_id", u.customer_unique_id || ""
);
        const group = u.group_id || 1;
        setCurrentGroup(group);

      const genderValue =
        u.gender === 1 ? "male" : u.gender === 2 ? "female" : "";
      const createdInValue =
        u.created_in === "english"
          ? "English"
          : u.created_in === "arabic"
          ? "Arabic"
          : "";

        if (group === 1) {
          // B2C user
          reset({
            full_name:
              u.full_name || `${u.firstname || ""} ${u.middlename || ""} ${u.lastname || ""}`.trim(),
            mobile_number: u.phone || "",
            email: u.email || "",
            dob: u.dob ? dayjs(u.dob) : null,
            gender: u.gender,
            welcome_email: createdInValue,
          });
          setUserFormVals({
            firstname: u.firstname || "",
            lastname: u.lastname || "",
            email: u.email || "",
            mobile_number: u.phone || "",
            gender: genderValue,
            dob: u.dob || "",
            created_in: createdInValue,
          });
        } else if (group === 2) {
          // B2B user
          reset({
            full_name_ar:
              u.full_name_ar ||
              `${u.firstnamear || ""} ${u.middlenamear || ""} ${u.lastnamear || ""}`.trim(),
            full_name_en:
              u.full_name_en ||
              `${u.firstname || ""} ${u.middlename || ""} ${u.lastname || ""}`.trim(),
            id_type: u.id_type || "",
            id_value: u.id_value || "",
            building_no: u.building_no || "",
            street: u.street || "",
            contactPersonName: u.contactPersonName || "",
            country_id: u.country_id || "",
            city_id: u.city_id == 0 ? "0" : u.city_id,
            other_city: u.city || "",
            other_district: u.district_name || "",
            district_id: u.district_id == 0 ? "0" : u.district_id,
            postcode: u.postcode || "",
            phone_ext: u.phone_ext || "",
            phone: u.phone || "",
            email: u.email || "",
            customer_unique_id: u.customer_unique_id || "",
            dob: u.dob ? dayjs(u.dob) : null,
            gender: genderValue,
            welcome_email: createdInValue,
            customer_unique_id: u.customer_unique_id || "",
          });
          setAddressData(prev => ({
            ...prev,
            customer_unique_id: u.customer_unique_id || "",
            country_code: foundCountry?.code || "",
          }));
        }
      } catch (err) {
        console.error("Error in combined fetch:", err);
      }
    };

    fetchUserAndLocation();
  }, [id, props.address]);

  const tabSelect = (e, value) => {
    setSelectedTab(value)
  }

  const {
    handleSubmit,
    control,
    watch,
    reset,
    getValues,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      customer_type: "",

      // Individual
      full_name_en: "",
      full_name_ar: "",

      // Corporate
      corporate_name_en: "",
      corporate_name_ar: "",
      industry_type: "",

      // Common
      id_type: "",
      id_value: "",
      contactPersonName: "",
      building_no: "",
      street: "",
      country_id: "",
      city_id: "",
      district_id: "",
      other_city: "",
      other_district: "",
      postcode: "",
      phone_ext: "",
      phone: "",
      email: "",
      dob: null,
      gender: "",
      customer_unique_id: "",

    },
  });



  React.useEffect(() => {
    if (!user) return;

    const isCorporate =
      user.customer_type === "Corporate" || user.group_id === 2;

    if (isCorporate) {
      // ✅ CORPORATE — ONLY 3 FIELDS + COMMON META
      reset({
        customer_type: "Corporate",

        // 🔑 Derived because backend does NOT send them
        corporate_name_en: `${user.firstname || ""} ${user.middlename || ""} ${user.lastname || ""}`.trim(),
        corporate_name_ar: `${user.firstnamear || ""} ${user.middlenamear || ""} ${user.lastnamear || ""}`.trim(),

        industry_type: user.industry_type || "",

        // common (read-only / shared)
        contactPersonName: user.contactPersonName || "",
        id_type: user.id_type || "",
        id_value: user.id_value || "",
        country_id: user.country_id || "",
        city_id: user.city_id == 0 ? "0" : user.city_id,
        district_id: user.district_id == 0 ? "0" : user.district_id,
       // customer_unique_id: user.customer_unique_id || "",
        postcode: user.postcode || "",
        phone_ext: user.phone_ext || "",
        phone: user.phone || "",
        email: user.email || "",
      });
      setValue( "customer_unique_id",user.customer_unique_id || "");
      setValue( "country_code",countryCode || "QA");
    } else {
      // Individual customer fields must survive the user-load reset.
      reset({
        ...getValues(),
        firstname: [user.firstname, user.middlename, user.lastname].filter(Boolean).join(" "),
        mobile_number: user.phone || "",
        customer_type: "Individual",

        full_name_en: `${user.firstname || ""} ${user.middlename || ""} ${user.lastname || ""}`.trim(),
        full_name_ar: `${user.firstnamear || ""} ${user.middlenamear || ""} ${user.lastnamear || ""}`.trim(),
        //customer_unique_id: user.customer_unique_id || "",
        phone: user.phone || "",
        email: user.email || "",
        dob: user.dob ? dayjs(user.dob) : null,
        gender: user.gender,
        customer_unique_id: user.customer_unique_id || "",

      });
    }
  }, [user, reset]);

const isGroupB2B = currentGroup === 2;
const isSaudi = countryCode === "SA";

const allowOtherCity =
  !isSaudi ||
  cityCode === "Others" ||
  watch("city_id") === "0";

const allowOtherDistrict =
  !isSaudi ||
  districtCode === "Others" ||
  watch("district_id") === "0";

  

const filteredCityListEdit = React.useMemo(() => {
  if (!citySearchEdit) return cityList;

  return cityList.filter((city) =>
    (city.value || "")
      .toLowerCase()
      .includes(citySearchEdit.toLowerCase())
  );
}, [citySearchEdit, cityList]);

// const filteredDistrictListEdit = React.useMemo(() => {
//   if (!districtSearchEdit) return districtList;

//   return districtList.filter((district) =>
//     (district.value || "")
//       .toLowerCase()
//       .includes(districtSearchEdit.toLowerCase())
//   );
// }, [districtSearchEdit, districtList]);


const filteredDistrictListEdit = React.useMemo(() => {
  if (!districtList.length) return [];

  let list = [];

  // 1️⃣ Filter by selected city
  if (watch("city_id") && watch("city_id") !== "0") {
    const selectedCity = cityList.find(
      (city) => city.id == watch("city_id")
    );

    if (selectedCity) {
      list = districtList.filter(
        (district) => districtBelongsToCity(district, selectedCity)
      );
    }
  }

  // 2️⃣ EDIT SAFETY: ensure selected district exists
  if (watch("district_id") && watch("district_id") !== "0") {
    const selectedDistrict = districtList.find(
      (d) => d.id == watch("district_id")
    );

    if (
      selectedDistrict &&
      !list.some((d) => d.id == selectedDistrict.id)
    ) {
      list = [selectedDistrict, ...list];
    }
  }

  // 3️⃣ Search
  if (!districtSearchEdit) return list;

  return list.filter((district) =>
    (district.value || "")
      .toLowerCase()
      .includes(districtSearchEdit.toLowerCase())
  );
}, [
  watch("city_id"),
  watch("district_id"),
  districtSearchEdit,
  cityList,
  districtList
]);



  const redirect = useRedirect()
const customerType = watch("customer_type");
  const idType = watch("id_type");

const showError = (msg, fieldName) => {
      // set inline error if react-hook-form setError exists
      try {
        if (fieldName) setError(fieldName, { type: "manual", message: msg });
      } catch (e) { }
      // show snackbar
      handleAlertGen(msg);
      // focus input if possible
      if (fieldName) {
        const el = document.querySelector(`[name="${fieldName}"]`);
        if (el && typeof el.focus === "function") {
          el.focus();
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    };
  

  const parseDocs = (docs) => {
    if (!docs) return [];

    let list = [];

    if (Array.isArray(docs)) {
      list = docs;
    } else if (typeof docs === "string") {
      try {
        const parsed = JSON.parse(docs);
        list = Array.isArray(parsed) ? parsed : [];
      } catch {
        list = docs.split(",");
      }
    }

    return list
      .map((item) => {
        if (!item) return null;

        if (typeof item === "object") {
          return item.path || item.url || null;
        }

        if (typeof item === "string") {
          return item.trim();
        }

        return null;
      })
      .filter(Boolean)
      .map((item) =>
        item.startsWith("http")
          ? item
          : `${process.env.REACT_APP_MEDIA_CDN_PATH}/${item.replace(/^\/+/, "")}`
      );
  };

  const getUser = () => {
    const data = { user_id: id };
    const signedToken = generateToken(data);
    axios
      .get(`${legolasApi.url}/admin/user/solo`, {
        headers: {
          Authorization: `Bearer ${signedToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.success) {
          const u = res.data.data;
          setUser(u);
          const parsedIdDocs = parseDocs(u.idProofDocument);
          const parsedAddressDocs = parseDocs(u.addressProofDocument);

          setIdDocs(parsedIdDocs);
          setAddressDocs(parsedAddressDocs);
          const group = u.group_id || 1;
          setCurrentGroup(group);
          const foundCountry = countryList.find(country => country.id == u.country_id)
          console.log('foundCountryssssss', foundCountry)
          if (group !== 1) {
            setCountryCode(foundCountry.code)
            setCityList(foundCountry.cities);
            setDistrictList(foundCountry.districts);
          }

        const genderValue =
          u.gender === 1 ? "male" : u.gender === 2 ? "female" : "";

        const createdInValue =
          u.created_in === "english"
            ? "English"
            : u.created_in === "arabic"
            ? "Arabic"
            : "";

          if (group === 1) {
            reset({

              full_name:
                u.full_name ||
                `${u.firstname || ""} ${u.middlename || ""} ${u.lastname || ""}`.trim(),
              mobile_number: u.phone || "",
              email: u.email || "",
              dob: u.dob ? dayjs(u.dob) : null,
              gender: u.gender,
              welcome_email: createdInValue, // 👈 store same language here
            });
            // Group 1 (B2C)
            setUserFormVals({
              firstname: u.firstname || "",
              lastname: u.lastname || "",
              email: u.email || "",
              mobile_number: u.phone || "",
              gender: genderValue,
              dob: u.dob || "",
              created_in: createdInValue, // 👈 language dropdown value
            });
          } else if (group === 2) {
            console.log('check userrr ', u)
            // Group 2 (B2B)
            reset({
              full_name_ar: u.full_name_ar ||
                `${u.firstnamear || ""} ${u.middlenamear || ""} ${u.lastnamear || ""}`.trim(),
              full_name_en:
                u.full_name_en ||
                `${u.firstname || ""} ${u.middlename || ""} ${u.lastname || ""}`.trim(),
              id_type: u.id_type || "",
              id_value: u.id_value || "",
              building_no: u.building_no || "",
              street: u.street || "",
              customer_type: u.customer_type || "",
              contactPersonName: u.contactPersonName || "",
              industry_type: u.industry_type || "",
              country_id: u.country_id || "",
              city_id: u.city_id == 0 ? "0" : u.city_id,
              other_city: u.city || "",
              other_district: u.district_name || "",
              district_id: u.district_id == 0 ? "0" : u.district_id,
              postcode: u.postcode || "",
              phone_ext: u.phone_ext || "",
              phone: u.phone || "",
              email: u.email || "",
              dob: u.dob ? dayjs(u.dob) : null,
              gender: genderValue,
              welcome_email: createdInValue,
              customer_unique_id: user.customer_unique_id || "",

            });
          }
        }
      })
      .catch((err) => console.error("Error fetching user:", err));
  };

  React.useEffect(() => {
    if (!user || currentGroup !== 2) return;

    const isCorporate = user.customer_type === "Corporate";

    const baseFields = {
      id_type: user.id_type || "",
      id_value: user.id_value || "",
      building_no: user.building_no || "",
      street: user.street || "",
      industry_type: user.industry_type || "",
      contactPersonName: user.contactPersonName || "",
      country_id: user.country_id || "",
      city_id: user.city_id == 0 ? "0" : user.city_id,
      other_city: user.city || "",
      other_district: user.district_name || "",
      district_id: user.district_id == 0 ? "0" : user.district_id,
      postcode: user.postcode || "",
      phone_ext: user.phone_ext || "",
      phone: user.phone || "",
      email: user.email || "",
      dob: user.dob ? dayjs(user.dob) : null,
      gender:
        user.gender === 1 ? "male" :
          user.gender === 2 ? "female" : "",
      welcome_email: user.welcome_email || "",
    };

    if (isCorporate) {
      reset({
        ...baseFields,
        customer_type: "Corporate",

        corporate_name_en: `${user.firstname || ""} ${user.middlename || ""} ${user.lastname || ""}`.trim(),
        corporate_name_ar: `${user.firstnamear || ""} ${user.middlenamear || ""} ${user.lastnamear || ""}`.trim(),
      });
    } else {
      reset({
        ...baseFields,
        customer_type: "Individual",

        full_name_en:
          user.full_name_en ||
          `${user.firstname || ""} ${user.middlename || ""} ${user.lastname || ""}`.trim(),

        full_name_ar:
          user.full_name_ar ||
          `${user.firstnamear || ""} ${user.middlenamear || ""} ${user.lastnamear || ""}`.trim(),
      });
    }
  }, [user, currentGroup, reset]);


  // General customer location fields are independent of the wholesale form.
  React.useEffect(() => {
    if (!user || currentGroup !== 1) return;
    setValue("general_country_id", user.country_id == null ? "" : String(user.country_id));
    setValue("general_city_id", user.city_id == null ? "" : String(user.city_id));
    setValue("general_district_id", user.district_id == null ? "" : String(user.district_id));
    setValue("general_customer_unique_id", user.customer_unique_id || "");
    setGeneralCitySearch("");
    setGeneralDistrictSearch("");
    setValue("general_city", user.city || "");
    setValue("general_district", user.district_name || user.district || "");
  }, [user, currentGroup, setValue]);

  const generalCountry = generalCountries.find(c => String(c.id) === watch("general_country_id"));
  const generalPhoneCountry = countryExtCodes.find(c => c.code === generalCountry?.code);
  const generalCities = sortAZ(generalCountry?.cities || []);
  const generalCity = generalCities.find(c => String(c.id) === watch("general_city_id"));
  const generalDistricts = sortAZ(generalCountry?.districts || []).filter(d =>
    String(d.id) !== "0" && generalCity && districtBelongsToCity(d, generalCity)
  );

  const handleChangeform = (e) => {
    const { name, value } = e.target;
    setAddressData((prev) => ({ ...prev, [name]: value }));
  };


  const handleSnackClose = () => {
    setOpen(false);
    setDeleteOpen(false);
    setResetOpen(false);
    setEditOpen(false);
  };


  const handleChangeReset  =(event)=>{
  const {name,value} = event.target
    setResetFormVals({ ...resetFormvals, [name]: value })
  }

  const splitName = (name = "") => ({
    firstname: String(name || "").trim(),
    middlename: null,
    lastname: null,
  });

  const onInvalidSave = (errors) => {
    const first = Object.entries(errors)[0];
    setTabValue(1);
    showError(first?.[1]?.message || "Please correct the highlighted customer fields.", first?.[0]);
  };

  const handleAction = (status, action , formData) =>{
      setMessage(null);
      setAction(action);
      if(action ==="Delete"  ){
        setcustomerModal(status);
      }
//       else if(action ==="SaveAndEdit" || action ==='Save'){      
//         console.log('coming here to set model')  
//        // setPendingFormData(formData); 
//        setPendingFormData({
//   ...formData,
//   phone_ext: getValues('phone_ext') || countryPhoneExt
// });
//         setEditModal(status)
//       }
else if (action === "Save" || action === "SaveAndEdit") {

    if (currentGroup === 1) {
      const country = generalCountries.find(c => String(c.id) === formData.general_country_id);
      const city = country?.cities?.find(c => String(c.id) === formData.general_city_id);
      const district = country?.districts?.find(d => String(d.id) === formData.general_district_id);
      if (!country) return showError("Please select a country!", "general_country_id");
      if (!city && formData.general_city_id !== "0") return showError("Please select a city!", "general_city_id");
      if (formData.general_city_id === "0" && !formData.general_city?.trim()) return showError("Please enter a city name!", "general_city");
      if (formData.general_district_id !== "0" && (!district || !city || !districtBelongsToCity(district, city))) return showError("Please select a district!", "general_district_id");
      if (formData.general_district_id === "0" && !formData.general_district?.trim()) return showError("Please enter a district name!", "general_district");
      const phoneCountry = countryExtCodes.find(c => c.code === country.code);
      if (!phoneCountry) return showError("Please select a valid country!", "general_country_id");
      if (!new RegExp(phoneCountry.regEx).test(formData.mobile_number || "")) {
        return showError(`Invalid phone number format. Expected: ${phoneCountry.pHolder}`, "mobile_number");
      }
      if (country.code === "QA" && !/^\d{11}$/.test(formData.general_customer_unique_id || "")) {
        return showError("Qatari ID must be exactly 11 digits!", "general_customer_unique_id");
      }
      setPendingFormData({
        ...formData,
        phone_ext: phoneCountry.text,
        customer_unique_id: country.code === "QA" ? formData.general_customer_unique_id : null,
        country_id: country.id,
        country: country.value,
        city_id: formData.general_city_id,
        city: formData.general_city_id === "0" ? formData.general_city.trim() : city.value,
        district_id: formData.general_district_id,
        district: formData.general_district_id === "0" ? formData.general_district.trim() : district.value,
      });
      setEditModal(true);
      return;
    }

    const rawPostcode = (formData.postcode || "").toString().trim();

    // find country
    const foundCountry = countryList.find(c =>
        c.id == formData.country_id || c.code == formData.country_id
    );

    if (!foundCountry) return showError("Please select a valid country.", "country_id");

    // VALIDATE POSTCODE BEFORE OPENING MODAL
    if (foundCountry?.code === "SA") {
        if (!/^\d{5}$/.test(rawPostcode)) {
            return showError("For Saudi Arabia, postcode must be exactly 5 digits", "postcode");
        }
    } else {
        if (!/^\d{9}$/.test(rawPostcode)) {
            return showError("Postcode must be exactly 9 digits", "postcode");
        }
    }

    // VALIDATE PHONE BEFORE OPENING MODAL
    const selectedCountry = countryExtCodes.find(
        (c) => c.code == (foundCountry?.code || 'SA')
    );
    if (!selectedCountry) return showError("Please select a valid country.", "country_id");
    const phoneRegex = new RegExp(selectedCountry.regEx);

    if (!phoneRegex.test(formData.phone || "")) {
        return showError(
            `Invalid phone number format. Expected: ${selectedCountry.pHolder}`,
            "phone"
        );
    }

    const isCorporate = formData.customer_type === "Corporate";

    const fullEn = isCorporate ? formData.corporate_name_en : formData.full_name_en;
    const fullAr = isCorporate ? formData.corporate_name_ar : formData.full_name_ar;

    const en = splitName(fullEn || "");
    const ar = splitName(fullAr || "");

    // IF VALIDATION PASSES → now store form data and open modal
    setPendingFormData({
        ...formData,
        phone_ext: getValues("phone_ext") || countryPhoneExt,

        firstname: en.firstname,
        middlename: en.middlename,
        lastname: en.lastname,

        firstnamear: ar.firstname,
        middlenamear: ar.middlename,
        lastnamear: ar.lastname,
    });

    setEditModal(true); // open modal only after validation passes
}
      else{
        setresetModal(status);
    }
  }


  const handleUserAction =() =>{
    
    if ((action === "Save" || action === "SaveAndEdit") && currentGroup === 1) {
      const payload = {
        id: user.id,
        firstname: String(pendingFormData.firstname || "").trim(),
        middlename: null,
        lastname: null,
        country_id: pendingFormData.country_id,
        country: pendingFormData.country,
        city_id: pendingFormData.city_id,
        city: pendingFormData.city,
        district_id: pendingFormData.district_id,
        district: pendingFormData.district,
        phone_ext: pendingFormData.phone_ext,
        customer_unique_id: pendingFormData.customer_unique_id,
        phone: pendingFormData.mobile_number,
        gender: pendingFormData.gender,
      };
      axios.post(`${legolasApi.url}/admin/updateuser`, { action: "userupdate" }, {
        headers: { Authorization: `Bearer ${generateToken(payload)}`, "Content-Type": "application/json" },
      }).then((res) => {
        if (!res.data.success) return showError(res.data.message || "Unable to update customer.");
        handleCloseEdit();
        setEditOpen(true);
        if (action === "Save") redirect('/users');
        else getUser();
      }).catch((error) => showError(error.response?.data?.message || "Unable to update customer. Please try again."));
      return;
    }

    if(action =="Delete"){
      let payload ={
      "customer_id": params.id 
      }
      let url =`${legolasApi.url}/auth/account/deactivate`
      axios.post(url,payload).then((res)=>{
        setcustomerModal(res.data)
        handleClose()
        if (res.data.success) {
          setDeleteOpen(true)
        }
       
      })
    }
    else if(action =="ResetPassword" ){
      if (resetFormvals.newpassword ==='' || resetFormvals.confrmpassword === '') {
          // setMessage(<h5 style={{ color: 'red' }}> Please enter password</h5>);
          setMessage(<h6 style={{ color: 'red',fontSize:'12px',textAlign:"centre",marginLeft:"-10px" }}> Please enter password</h6>);

                 return false;
          }

      else if (resetFormvals.newpassword !== resetFormvals.confrmpassword) {
          // setMessage(<h5 style={{ color: 'red' }}>  Entered password did not match </h5>);
          setMessage(<h6 style={{ color: 'red' ,fontSize:'12px',textAlign:"centre"}}>  Entered password did not match </h6>);

                  return false;
          }
          
      else if (resetFormvals.newpassword.length < 8 || resetFormvals.newpassword.length >20) {
          // setMessage(<h5 style={{ color: 'red' }}> Please  enter min 8 character & max 20 character </h5>);
          setMessage(<h6 style={{ color: 'red' ,fontSize:'12px',textAlign:"centre"}}> Please  enter min 8 character & max 20 character </h6>);

                  return false; 
                }
      else { 
          setMessage(null);
          
           }

      // if(!isEmpty(resetFormvals.newpassword) && !isEmpty(resetFormvals.confrmpassword) 
      // && resetFormvals.newpassword ===resetFormvals.confrmpassword   && ( resetFormvals.newpassword) >=6)  {
        const data ={
          "userId" :params.id,
          "newPassword":resetFormvals.newpassword,
          "confrmPassword":resetFormvals.confrmpassword
          }
          const signedToken = generateToken(data)
          const payload ={"action":"reset-password"}
          const url =`${legolasApi.url}/admin/user/password/reset`
          axios.post(url,payload,{
          headers: {
          'Authorization': `Bearer ${signedToken}`,
          'Content-Type': 'application/json'
          }
        }).then((res) =>{
  
            setresetModal(res.data);
            handleCloseReset()
            
            console.log("reset password response : ",res.data);
            if (res.data.success) {
              setResetOpen(true)
            }
          });
          
          // else{
          //  setMessage(<h5 style= {{color : 'red'}}> Please Enter Correct Password </h5>)
          // }
    }
    
    else if (action == "SaveAndEdit"){
      console.log("form data in save and edit", pendingFormData);
// const full_name_en =
//       pendingFormData.customer_type === "Corporate"
//         ? pendingFormData.corporate_name_en
//         : pendingFormData.full_name_en;

//     const full_name_ar =
//       pendingFormData.customer_type === "Corporate"
//         ? pendingFormData.corporate_name_ar
//         : pendingFormData.full_name_ar;

//     if (!full_name_en?.trim()) {
//       return showError("Name (English) is required", "full_name_en");
//     }
//     if (!full_name_ar?.trim()) {
//       return showError("Name (Arabic) is required", "full_name_ar");
//     }
// DOCUMENTS
let idProofDocument = undefined;
let addressProofDocument = undefined;

// Only set if user uploaded new doc
if (pendingFormData.id_document) {
  idProofDocument = JSON.stringify([pendingFormData.id_document]);
}

if (pendingFormData.address_document) {
  addressProofDocument = JSON.stringify([pendingFormData.address_document]);
}

const isCorporate = pendingFormData.customer_type === "Corporate";

const full_name_en = isCorporate
  ? pendingFormData.corporate_name_en
  : pendingFormData.full_name_en;

const full_name_ar = isCorporate
  ? pendingFormData.corporate_name_ar
  : pendingFormData.full_name_ar;

if (!full_name_en?.trim()) {
  return showError("Name (English) is required", "full_name_en");
}

if (!full_name_ar?.trim()) {
  return showError("Name (Arabic) is required", "full_name_ar");
}
const en = splitName(full_name_en);
    const ar = splitName(full_name_ar);

      const foundCountry = countryList.find((c) => c.id == (pendingFormData.country_id || 'SA'));
     const rawPostcode = (pendingFormData.postcode || "").toString().trim();

const isSaudi = foundCountry?.code === "SA";

      if (isSaudi) {
        if (!/^\d{5}$/.test(rawPostcode)) {
          return showError("For Saudi Arabia, postcode must be exactly 5 digits", "postcode");
        }
      } else {
        if (!/^\d{9}$/.test(rawPostcode)) {
          return showError("Postcode must be exactly 9 digits", "postcode");
        }
      }
      const isVat = pendingFormData.id_type === "VAT Number";

      const isVatOrCr = ["VAT Number", "CR Number"].includes(
        pendingFormData.id_type
      );

      // VAT validation
      if (isVat) {
        const vatNumber = pendingFormData.id_value?.toString().trim() || "";

        if (!isValidSaudiVAT(vatNumber)) {
          setEditOpen(false);
          handleCloseEdit();

          return showError(
            "VAT Number must be exactly 15 digits, start with 3, and end with 03!",
            "id_value"
          );
        }
      }

      // ID Proof validation
      const hasExistingIdDoc =
        parseDocs(user?.idProofDocument).length > 0;

      const hasNewIdDoc = !!pendingFormData.id_document;

      if (isVatOrCr && !hasExistingIdDoc && !hasNewIdDoc) {
        setEditOpen(false);
        handleCloseEdit();

        return showError(
          "ID Proof document is required for VAT / CR customers!",
          "id_document"
        );
      }
      const selectedCountryCode = foundCountry?.code || "SA";

      if (selectedCountryCode === "QA") {
        const qatarId = (
          pendingFormData.customer_unique_id ||
          addressData.customer_unique_id ||
          ""
        ).trim();

        if (!qatarId) {
          return showError(
            "Qatari ID is required for Qatar customers!",
            "customer_unique_id"
          );
        }

        if (!/^\d{11}$/.test(qatarId)) {
          return showError(
            "Qatari ID must be exactly 11 digits!",
            "customer_unique_id"
          );
        }
      }
      const foundCity = foundCountry?.cities?.find(c => c.id == pendingFormData.city_id);
      const foundDist = foundCountry.districts?.find(c => c.id == pendingFormData.district_id);


      const data = {
        "id": user.id,
        gender: pendingFormData.gender === "male" || pendingFormData.gender === 1 ? 1 : pendingFormData.gender === "female" || pendingFormData.gender === 2 ? 2 : undefined,
firstname: en.firstname,
      middlename: en.middlename,
      lastname: en.lastname,

      firstnamear: ar.firstname,
      middlenamear: ar.middlename,
      lastnamear: ar.lastname,

        full_name_en: full_name_en.trim(),
        full_name_ar: full_name_ar.trim(),
        customer_unique_id: foundCountry?.code === "QA" ? (pendingFormData.customer_unique_id || addressData.customer_unique_id || "") : null,

        // full_name_en: full_name_en.trim(),
  //full_name_ar: full_name_ar.trim(),

 
  //       corporate_name_en:
  //   pendingFormData.corporate_name_en || pendingFormData.full_name_en || "",

  // corporate_name_ar:
  //   pendingFormData.corporate_name_ar || pendingFormData.full_name_ar || "",
  //       full_name_en: full_name_en.trim(),
  //       full_name_ar: full_name_ar.trim(),
        //"firstname": pendingFormData.full_name_en && pendingFormData.full_name_en.split(' ')[0] || pendingFormData.full_name && pendingFormData.full_name.split(' ')[0],
        // "middlename": pendingFormData.middlename,
        //"lastname": pendingFormData.full_name_en && pendingFormData.full_name_en.split(' ')[1] || pendingFormData.full_name && pendingFormData.full_name.split(' ')[1],
        //"firstnamear": pendingFormData.full_name_ar && pendingFormData.full_name_ar.split(' ')[0],
        // "middlenamear": pendingFormData.full_name_en,
        //"lastnamear": pendingFormData.full_name_ar && pendingFormData.full_name_ar.split(' ')[1],
        // "phone": `${pendingFormData.phone_ext || ''}${pendingFormData.phone || pendingFormData.mobile_number || ''}`,
        "phone": `${pendingFormData.phone || pendingFormData.mobile_number || ''}`,

        // 'phone': pendingFormData.phone || pendingFormData.mobile_number,
        'gender': pendingFormData.gender == 'male' || pendingFormData.gender == 1 ? 1 : 2,
        'country': foundCountry.value != "Others" ? foundCountry.value : pendingFormData.country,
        'city': foundCity.value != "Others" ? foundCity.value : pendingFormData.other_city,
        'district': foundDist.value != "Others" ? foundDist.value : pendingFormData.other_district,
        'district_id': pendingFormData.district_id,
        'city_id': pendingFormData.city_id,
        'country_id': pendingFormData.country_id,
        'postcode': rawPostcode,
        'building_no': pendingFormData.building_no,
        'street': pendingFormData.street,
        'contactPersonName': pendingFormData.contactPersonName,
        'customer_type': pendingFormData.customer_type || "",
        'industry_type': pendingFormData.industry_type || "",
        'id_type': pendingFormData.id_type,
        'id_value': pendingFormData.id_value,
        // 'created_in' : pendingFormData.created_in,
        "dob": pendingFormData.dob,
        "wholesale_type": pendingFormData.wholesale_type,
       // "idProofDocument": pendingFormData.id_document ? JSON.stringify([pendingFormData.id_document]) : null,
       // "addressProofDocument": pendingFormData.address_document ? JSON.stringify([pendingFormData.address_document]) : null,

      };
      if (idProofDocument !== undefined) {
  data.idProofDocument = idProofDocument;
}

if (addressProofDocument !== undefined) {
  data.addressProofDocument = addressProofDocument;
}
      console.log("data to be sent", data);
      const signedToken = generateToken(data)
      const payload = { "action": "userupdate" }
      const url = `${legolasApi.url}/admin/updateuser`
      axios.post(url, payload, {
        headers: {
          'Authorization': `Bearer ${signedToken}`,
          'Content-Type': 'application/json'
        }
      }).then((res) => {
        if (!res.data.success) return showError(res.data.message || "Unable to update customer.");
        handleCloseEdit()
        if (res.data.success) {
          setEditOpen(true)
          getUser()
        }
        console.log('save user res', res.data)
      }).catch((error) => showError(error.response?.data?.message || "Unable to update customer. Please try again."))
    }
    else if (action == "Save") {
      // const full_name_en =
      //   pendingFormData.customer_type === "Corporate"
      //     ? pendingFormData.corporate_name_en
      //     : pendingFormData.full_name_en;

      // const full_name_ar =
      //   pendingFormData.customer_type === "Corporate"
      //     ? pendingFormData.corporate_name_ar
      //     : pendingFormData.full_name_ar;

      // if (!full_name_en?.trim()) {
      //   return showError("Name (English) is required", "full_name_en");
      // }
      // if (!full_name_ar?.trim()) {
      //   return showError("Name (Arabic) is required", "full_name_ar");
      // }
      let idProofDocument = undefined;
let addressProofDocument = undefined;

// Only set if user uploaded new doc
if (pendingFormData.id_document) {
  idProofDocument = JSON.stringify([pendingFormData.id_document]);
}

if (pendingFormData.address_document) {
  addressProofDocument = JSON.stringify([pendingFormData.address_document]);
}

     const isCorporate = pendingFormData.customer_type === "Corporate";

const full_name_en = isCorporate
  ? pendingFormData.corporate_name_en
  : pendingFormData.full_name_en;

const full_name_ar = isCorporate
  ? pendingFormData.corporate_name_ar
  : pendingFormData.full_name_ar;

if (!full_name_en?.trim()) {
  return showError("Name (English) is required", "full_name_en");
}

if (!full_name_ar?.trim()) {
  return showError("Name (Arabic) is required", "full_name_ar");
}
const en = splitName(full_name_en);
    const ar = splitName(full_name_ar);

      console.log("form data in save", pendingFormData);
      const foundCountry = countryList.find((c) => c.id == (pendingFormData.country_id || '1') || c.code == (pendingFormData.country_id || '1'));
      if (!foundCountry) return showError("Please select a valid country.", "country_id");
      const selectedCountry = countryExtCodes.find((c) => c.code == foundCountry.code);
      console.log("Selected country for phone validation:", selectedCountry);
      if (!selectedCountry) return showError("Please select a valid country.", "country_id");
    const phoneRegex = new RegExp(selectedCountry.regEx);
      if (!phoneRegex.test(pendingFormData.phone || '')) {
        console.log("Invalid phone number format. Expected:", selectedCountry.pHolder);
        setEditOpen(false)
        handleCloseEdit()
        return showError(`Invalid phone number format. Expected: ${selectedCountry.pHolder}`, "phone");
      }
      const rawPostcode = (pendingFormData.postcode || "").toString().trim();

      const isSaudi = foundCountry?.code === "SA";

      if (isSaudi) {
        if (!/^\d{5}$/.test(rawPostcode)) {
          setEditOpen(false)
          handleCloseEdit()
          return showError("For Saudi Arabia, postcode must be exactly 5 digits", "postcode");
        }
      } else {
        if (!/^\d{9}$/.test(rawPostcode)) {
          setEditOpen(false)
          handleCloseEdit()
          return showError("Postcode must be exactly 9 digits", "postcode");
        }
      }
      const isVat = pendingFormData.id_type === "VAT Number";

      const isVatOrCr = ["VAT Number", "CR Number"].includes(
        pendingFormData.id_type
      );

      // VAT validation
      if (isVat) {
        const vatNumber = pendingFormData.id_value?.toString().trim() || "";

        if (!isValidSaudiVAT(vatNumber)) {
          setEditOpen(false);
          handleCloseEdit();

          return showError(
            "VAT Number must be exactly 15 digits, start with 3, and end with 03!",
            "id_value"
          );
        }
      }

      // ID Proof validation
      const hasExistingIdDoc =
        parseDocs(user?.idProofDocument).length > 0;

      const hasNewIdDoc = !!pendingFormData.id_document;

      if (isVatOrCr && !hasExistingIdDoc && !hasNewIdDoc) {
        setEditOpen(false);
        handleCloseEdit();

        return showError(
          "ID Proof document is required for VAT / CR customers!",
          "id_document"
        );
      }
      const selectedCountryCode = foundCountry?.code || "SA";

      if (selectedCountryCode === "QA") {
        const qatarId = (
          pendingFormData.customer_unique_id ||
          addressData.customer_unique_id ||
          ""
        ).trim();

        if (!qatarId) {
          return showError(
            "Qatari ID is required for Qatar customers!",
            "customer_unique_id"
          );
        }

        if (!/^\d{11}$/.test(qatarId)) {
          return showError(
            "Qatari ID must be exactly 11 digits!",
            "customer_unique_id"
          );
        }
      }
      const foundCity = foundCountry?.cities?.find(c => c.id == pendingFormData.city_id);
      const foundDist = foundCountry.districts?.find(c => c.id == pendingFormData.district_id);
      console.log(foundCountry, foundCity, foundDist);
      const data = {
        "id": user.id,
        gender: pendingFormData.gender === "male" || pendingFormData.gender === 1 ? 1 : pendingFormData.gender === "female" || pendingFormData.gender === 2 ? 2 : undefined,
        firstname: en.firstname,
      middlename: en.middlename,
      lastname: en.lastname,

      firstnamear: ar.firstname,
      middlenamear: ar.middlename,
      lastnamear: ar.lastname,

        full_name_en: full_name_en.trim(),
        full_name_ar: full_name_ar.trim(),
        customer_unique_id: foundCountry?.code === "QA" ? (pendingFormData.customer_unique_id || addressData.customer_unique_id || "") : null,
        //        full_name_en: full_name_en.trim(),
        // full_name_ar: full_name_ar.trim(),

  //       corporate_name_en:
  //   pendingFormData.corporate_name_en || pendingFormData.full_name_en || "",

  // corporate_name_ar:
  //   pendingFormData.corporate_name_ar || pendingFormData.full_name_ar || "",
  //       full_name_en: full_name_en.trim(),
  //       full_name_ar: full_name_ar.trim(),
        //"firstname": pendingFormData.full_name_en && pendingFormData.full_name_en.split(' ')[0] || pendingFormData.full_name && pendingFormData.full_name.split(' ')[0],
        // "middlename": pendingFormData.middlename,
        // "lastname": pendingFormData.full_name_en && pendingFormData.full_name_en.split(' ')[1] || pendingFormData.full_name && pendingFormData.full_name.split(' ')[1],
        // "firstnamear": pendingFormData.full_name_ar && pendingFormData.full_name_ar.split(' ')[0],
        // "middlenamear": pendingFormData.full_name_en,
        // "lastnamear": pendingFormData.full_name_ar && pendingFormData.full_name_ar.split(' ')[1],
        "phone": `${pendingFormData.phone || pendingFormData.mobile_number || ''}`,

        "phone_ext": `${pendingFormData.phone_ext || ''}`,
        //'phone': pendingFormData.phone || pendingFormData.mobile_number,
        // 'gender' : pendingFormData.gender =='male'||pendingFormData.gender ==1 ? 1 : 2,
        'district_id': pendingFormData.district_id,
        'country': foundCountry.value != "Others" ? foundCountry.value : pendingFormData.country,
        // 'city' :foundCity.value !="Others" ?foundCity.value: pendingFormData.other_city,
        // 'district' :foundDist.value !="Others" ?foundDist.value: pendingFormData.other_district,        
        'city': foundCity?.value !== "Others" ? foundCity?.value : pendingFormData.other_city || "",
        'district': foundDist?.value !== "Others" ? foundDist?.value : pendingFormData.other_district || "",
        'city_id': pendingFormData.city_id,
        'country_id': foundCountry.id,
        'postcode': rawPostcode,
        'building_no': pendingFormData.building_no,
        'street': pendingFormData.street,
        'contactPersonName': pendingFormData.contactPersonName,
        'customer_type': pendingFormData.customer_type || "",
        'industry_type': pendingFormData.industry_type || "",
        'id_type': pendingFormData.id_type,
        'id_value': pendingFormData.id_value,
        // 'created_in' : pendingFormData.created_in,
        "dob": pendingFormData.dob,
        "wholesale_type": pendingFormData.wholesale_type,
        //"idProofDocument": pendingFormData.id_document ? JSON.stringify([pendingFormData.id_document]) : null,
       // "addressProofDocument": pendingFormData.address_document ? JSON.stringify([pendingFormData.address_document]) : null,
      };
      if (idProofDocument !== undefined) {
  data.idProofDocument = idProofDocument;
}

if (addressProofDocument !== undefined) {
  data.addressProofDocument = addressProofDocument;
}
      console.log("data to be sent", data);
      const signedToken = generateToken(data)
      const payload = { "action": "userupdate" }
      const url = `${legolasApi.url}/admin/updateuser`
      axios.post(url, payload, {
        headers: {
          'Authorization': `Bearer ${signedToken}`,
          'Content-Type': 'application/json'
        }
      }).then(async (res) => {
        if (!res.data.success) return showError(res.data.message || "Unable to update customer.");
        handleCloseEdit()
        if (res.data.success) {
          setEditOpen(true)
          if (currentGroup === 2 && !user?.vinculum_cust_id) {
            try {
              await handleVinculumSync(user);
            } catch (e) {
              console.error("Vinculum sync failed", e);
            }
          }
          redirect('/users')


        }
        console.log('save user res', res.data)
      }).catch((error) => showError(error.response?.data?.message || "Unable to update customer. Please try again."))

    }

  }
  const validateBeforeSave = handleSubmit((data) => {
    // if validation OK → open modal
    handleAction(true, "Save", data);
  });

  const getwishList = () => {
    let submitPayload = {
      customer_id: params.id,
    }
    axios.post(`${legolasApi.url}/wishlist/wishlistitems`, submitPayload).then((res) => {
      console.log('Res: ', res)
      const data = res.data
      if (data.wishlist_items && isArray(data.wishlist_items)) {
        setListData(res.data.wishlist_items);
      }
      console.log(res.data);
    })
  }
  React.useEffect(() => {
    getwishList();
    getUserOrder();
  }, [page])


  const removeWishList = (id) => {
    let submitPayload = {
      customer_id: params.id,
      "mage_id": [id]
    }
    axios.post(`${legolasApi.url}/wishlist/removefromwishlist`, submitPayload).then((res) => {
      console.log('Response data: ', res)
      if (res.data.success) {
        setOpen(true)
      }
      console.log(res.data);
      getwishList();
    })
  }

  React.useEffect(() => {
    //console.log("Params-ID:",params.id)

    let submitPayload = {
      customer_id: params.id,

    }
    axios.post(`${legolasApi.url}/admin/user/shopping/cart`, submitPayload).then((res) => {

      console.log('search :', res)
      const data = res.data
      if (data.cartListItems && isArray(data.cartListItems)) {
        setcartItem(res.data.cartListItems)
      } else {
        setcartItem([])
      }
      console.log(res.data);
    })
  }, [])


  React.useEffect(() => {
    console.log('current user data')
    console.log(user)
    if (user?.group_id) {
      setCurrentGroup(user.group_id);
    }
  }, [user])




  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const redirectToList = () => {
    redirect('/users')
  }
  const getUserOrder = () => {

    const payload = { "user_id": params.id }
    axios.post(`${legolasApi.url}/admin/user/orders?page=${page}`, payload)
      .then((res) => {
        if (res.data.users && isArray(res.data.users) && res.data.users.length > 0) {
          setorderItem(res.data.users);
          setTotalcount(res.data.count)
        }
        console.log("user order", res.data);
      })
  }
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  function getModifiedDate(inpDate) {
    let modDate = new Date(inpDate)
    let retDate = ''
    const month = modDate.toLocaleDateString('default', { month: 'short' })
    const date = modDate.getDate()
    const year = modDate.getFullYear()
    const formattedTime = modDate.getHours() + ':' + modDate.getMinutes() + ':' + modDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }



  const controllerFields = {
    margin: '10px 17.5%',
    width: '500px',
    borderBottom: '2px solid #2b3f7a',
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: '#fff !important'
    }
  }

  const controllerDropdowns = {
    margin: '10px 17.5%',
    width: '500px',
    border: '2px solid #2b3f7a',
    borderRadius: 0
  }


  const listitemButtonStyle = {
    '&:hover': {
      backgroundColor: globalStyles.colors.backgroundSecondary,
      color: globalStyles.colors.white
    },
    '& .MuiListItemButton-root.Mui-selected': {
      backgroundColor: globalStyles.colors.backgroundPrimary,
      color: globalStyles.colors.white
    },
  }

  const handleOrderRedirect = (orderNo) => {
    const link = `/orders/${orderNo}`
    navigate(link, { state: { data: data, type: 'orders' } })
  }

  const handleVinculumSync = async (user) => {
    if (processingUsers[user.id]) return;

    try {
      setProcessingUsers(prev => ({
        ...prev,
        [user.id]: true
      }));

      const payload = { userId: user.id, group_id: user.group_id };
      const signedToken = generateToken(payload);

      const res = await axios.post(`${legolasApi.url}/admin/re-sync`, payload, {
        headers: { Authorization: `Bearer ${signedToken}` }
      });

      if (res.data.success) {
        handleAlertGen("Vinculum sync triggered");
      }

    } catch (err) {
      console.error(err);
      handleAlertGen("Sync failed");
    } finally {
      setProcessingUsers(prev => ({
        ...prev,
        [user.id]: false
      }));
    }
  };

  if (user == null) {
    return null
  } else {
    return (


      <Box sx={{ width: '100%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
        <Box sx={{
          display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
          '& .MuiTypography-root': {
            fontSize: '2.5rem',
            fontWeight: 400,
            color: '#000'
          }
        }}>
          <Typography>{user.firstname} {user.lastname}</Typography>
          <Box></Box>
        </Box>
        <Box>
          <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {
              setNavigationValue(newValue);
            }}
            sx={globalStyles.bottomNavigationMenu}
          >
            <Snackbar open={open} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
              <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                Wishlist Item Deleted Successfully
              </Alert>
            </Snackbar>
            <BottomNavigationAction label="Back" onClick={redirectToList} />
            <Snackbar open={deleteOpen} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
              <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                User Deleted Successfully
              </Alert>
            </Snackbar>
            <BottomNavigationAction label="Delete Customer" onClick={() => handleAction(true, "Delete")} />
            <Modal
              open={customerModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={globalStyles.modalContainer}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Are you sure you want to delete this customer?
                </Typography>
                <Box sx={{
                  display: 'flex', justifyContent: 'end', marginTop: '20px',
                  '& .MuiButton-root': {
                    color: globalStyles.colors.backgroundPrimary,
                    textTransform: 'capitalize'
                  }
                }}>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button onClick={handleUserAction}>OK</Button>
                </Box>
              </Box>
            </Modal>
            <Snackbar open={resetOpen} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
              <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                Password Change Successfully
              </Alert>
            </Snackbar>
            {/* <BottomNavigationAction label="Reset Password"  onClick={() => handleAction(true,"ResetPassword" )}/> */}
            <Modal
              open={resetModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={globalStyles.modalContainer}>
                {/* <Typography id="modal-modal-title" variant="h6" component="h2" sx={{color: globalStyles.colors.backgroundPrimary, textAlign :"center", */}
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{
                  color: globalStyles.colors.backgroundPrimary, textAlign: "center", marginTop: "-15px",

                  textTransform: 'capitalize'
                }}>
                  RESET
                </Typography>
                <Box sx={{
                  textAlign: "center", marginTop: '2px', height: "66px", padding: "5px", marginLeft: "-34px", paddingTop: "14px",
                  width: "119%"
                }}>

                  {message ? message : null}
                  <TextField
                    id="filled-password-input"
                    label="New Password"
                    type="password"
                    autoComplete="current-password"
                    rules={{ required: true }}
                    variant="filled"
                    value={resetFormvals.newpwd}
                    name="newpassword"
                    onChange={handleChangeReset}
                    sx={{
                      flex: 1,
                      marginRight: '2px', // Adjust the spacing between fields
                    }}
                  />
                  <TextField
                    id="filled-password-input"
                    label="Confirm Password"
                    type="password"
                    autoComplete="current-password"
                    rules={{ required: true }}
                    variant="filled"
                    value={resetFormvals.confrmpwd}
                    name="confrmpassword"
                    onChange={handleChangeReset}
                    sx={{
                      flex: 1,
                    }}
                  />

                </Box>
                <Box sx={{
                  display: 'flex', justifyContent: 'end', marginTop: '20px',
                  '& .MuiButton-root': {
                    color: globalStyles.colors.backgroundPrimary,
                    textTransform: 'capitalize'
                  }
                }}>

                  <Button onClick={handleCloseReset}>Cancel</Button>
                  <Button onClick={handleUserAction}>OK</Button>
                </Box>
              </Box>
            </Modal>

            {/* <BottomNavigationAction label="Create Order" /> */}

            {/* <BottomNavigationAction label="Force Sign-in"/> */}
            <Snackbar open={EditOpen} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
              <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
                User has been Updated Successfully
              </Alert>
            </Snackbar>

            {/* <BottomNavigationAction label="Save and Continue Edit" 
                onClick={() => handleSubmit((data) => handleAction(true, "SaveAndEdit", data))()}
              /> */}
            <Modal
              open={EditModal}
              onClose={handleCloseEdit}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={globalStyles.modalContainer}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Are you sure you want to save this customer?
                </Typography>
                <Box sx={{
                  display: 'flex', justifyContent: 'end', marginTop: '20px',
                  '& .MuiButton-root': {
                    color: globalStyles.colors.backgroundPrimary,
                    textTransform: 'capitalize'
                  }
                }}>
                  <Button onClick={handleCloseEdit}>Cancel</Button>
                  <Button onClick={handleUserAction}>OK</Button>
                </Box>
              </Box>
            </Modal>
            <BottomNavigationAction label="Save Customer"
              sx={{
                backgroundColor: '#2b3f7a !important',
                border: '2px solid #2b3f7a !important',
                color: '#fff !important'
              }}
              onClick={() => handleSubmit((data) => handleAction(true, "Save", data), onInvalidSave)()}
            // onClick={() => handleAction(true,"Save" , )}
            />
          </BottomNavigation>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} columns={24} sx={{ marginTop: '20px' }}>
            <Grid item xs={8}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={tabValue}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{
                  borderRight: 1, borderColor: 'divider',
                  '& .MuiTab-root': {
                    color: '#000',
                  },
                  '& .MuiTab-root.Mui-selected': {
                    color: '#2b3f7a !important'
                  }
                }}
              >
                <Tab label="Customer View" {...a11yProps(0)} />
                <Tab label="Account Information" {...a11yProps(1)} />
                <Tab label="Addresses" {...a11yProps(2)} />
                <Tab label="Orders" {...a11yProps(3)} />
                <Tab label="Shopping cart" {...a11yProps(4)} />
                <Tab label="Wish List" {...a11yProps(6)} />
              </Tabs>
            </Grid>
            <Grid item xs={16}>
              <TabPanel value={tabValue} index={0}>
                <AccountInformation {...user} />

              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <React.Fragment>
                  <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                    <Typography variant='h6'>Account Information</Typography>
                  </Box>
                  <Box sx={{ width: "90%" }}>
                    <form onSubmit={handleSubmit((data) => handleAction(true, "Save", data), onInvalidSave)}>
                      {currentGroup === 2 && (
                        <React.Fragment>
                          {/* CUSTOMER TYPE */}
                          <Controller
                            name="customer_type"
                            control={control}
                            rules={{ required: "Please select customer type" }}
                            defaultValue={userFormvals.customer_type || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Customer Type*"
                                InputProps={{ readOnly: true }}
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                              />
                            )}
                          />


                          {customerType === "Corporate" && (
                            <>
                              <Controller
                                name="corporate_name_en"
                                control={control}
                                rules={{ required: "Corporate Name (English) is required" }}
                                defaultValue={userFormvals.corporate_name_en || ""}

                                render={({ field, fieldState }) => (
                                  <TextField
                                    {...field}
                                    label="Corporate Name (English)*"
                                    fullWidth
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    sx={{ mb: 2 }}
                                  />
                                )}
                              />

    <Controller
      name="corporate_name_ar"
      control={control}
      rules={{ required: "Corporate Name (Arabic) is required" }}
      defaultValue={userFormvals.corporate_name_ar || ""}

      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label="Corporate Name (Arabic)*"
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          sx={{ mb: 2 }}
        />
      )}
    />

    <Controller
      name="industry_type"
      control={control}
      rules={{ required: "Industry Type is required" }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label="Industry Type*"
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          sx={{ mb: 2 }}
        />
      )}
    />
  </>
)}
                          {/* INDIVIDUAL */}
                          {/* {wholesaleType === "Individual" && (
                            <>
                              <Controller
                                name="full_name_ar"
                                control={control}
                                rules={{
                                  required: "Full Name (Arabic) is required",
                                  pattern: {
                                    value: /^[\u0600-\u06FF\s]+$/,
                                    message: "Please enter valid Arabic characters only",
                                  },
                                }}
                                defaultValue={userFormvals.full_name_ar || ""}
                                render={({ field, fieldState: { error } }) => (
                                  <TextField
                                    {...field}
                                    label="Full Name (Arabic)*"
                                    fullWidth
                                    error={!!error}
                                    helperText={error?.message}
                                    sx={{ mb: 2 }}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setValue("lastname", e.target.value || "");
                                      handleChangeform(e);
                                    }}
                                  />
                                )}
                              />

                              <Controller
                                name="full_name_en"
                                control={control}
                                rules={{
                                  required: "Full Name (English) is required",
                                  pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: "Only English letters are allowed",
                                  },
                                }}
                                defaultValue={userFormvals.full_name_en || ""}
                                render={({ field, fieldState: { error } }) => (
                                  <TextField
                                    {...field}
                                    label="Full Name (English)*"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    error={!!error}
                                    helperText={error?.message}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setValue("firstname", e.target.value || "");
                                      handleChangeform(e);
                                    }}
                                  />
                                )}
                              />
                            </>
                          )} */}
{customerType === "Individual" && (
  <>
    <Controller
      name="full_name_en"
      control={control}
      rules={{ required: "Full Name (English) is required" }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label="Full Name (English)*"
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          sx={{ mb: 2 }}
        />
      )}
    />

                              <Controller
                                name="full_name_ar"
                                control={control}
                                rules={{ required: "Full Name (Arabic) is required" }}
                                render={({ field, fieldState }) => (
                                  <TextField
                                    {...field}
                                    label="Full Name (Arabic)*"
                                    fullWidth
                                    error={!!fieldState.error}
                                    helperText={fieldState.error?.message}
                                    sx={{ mb: 2 }}
                                  />
                                )}
                              />
                            </>
                          )}

                          {/* ID TYPE + VALUE */}
                          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                            <Box sx={{ width: "20%", textAlign: "right", mt: 2 }}>Customer ID Type:</Box>
                            <Box sx={{ flex: 1, display: "flex", gap: 2 }}>
                              <Controller
                                name="id_type"
                                control={control}
                                rules={{ required: "ID Type is required" }}
                                defaultValue={userFormvals.id_type || ""}
                                render={({ field, fieldState: { error } }) => (
                                  <FormControl fullWidth error={!!error}>
                                    <Select {...field} displayEmpty>
                                      <MenuItem value="">- Select ID Type -</MenuItem>
                                      <MenuItem value="National ID">National ID</MenuItem>
                                      <MenuItem value="Iqama">Iqama</MenuItem>
                                      <MenuItem value="VAT Number">VAT Number</MenuItem>
                                      <MenuItem value="CR Number">CR Number</MenuItem>
                                      <MenuItem value="Other">Other</MenuItem>
                                    </Select>
                                    <FormHelperText>{error?.message}</FormHelperText>
                                  </FormControl>
                                )}
                              />

                              <Controller
                                name="id_value"
                                control={control}
                                rules={{ required: "ID Value is required" }}
                                defaultValue={userFormvals.id_value || ""}
                                render={({ field, fieldState: { error } }) => (
                                  <TextField {...field} label="ID Value*" fullWidth error={!!error} helperText={error?.message} />
                                )}
                              />
                            </Box>
                          </Box>

                          {currentGroup === 2 && (
                            <Box sx={{ mt: 4 }}>
                              <Box sx={{ display: "flex", gap: 2 }}>
                                {/* Left label column */}
                                <Box sx={{ width: "20%", textAlign: "right", pt: 1 }}>
                                  Uploaded Documents:
                                </Box>

                                {/* Right content */}
                                <Box sx={{ flex: 1 }}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 3,
                                      flexWrap: "wrap",
                                    }}
                                  >

                                    {/* ID Proof */}
                                    <Box sx={{ flex: 1, minWidth: 280, ml: 2 }}>
                                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        ID Proof
                                      </Typography>

                                      {idDocsRaw?.length > 0 ? (
                                        <DocumentPreview srcList={toPreviewUrls(idDocsRaw)} />
                                      ) : (
                                        <Typography color="text.secondary">
                                          No ID document found
                                        </Typography>
                                      )}
                                    </Box>

                                    {/* Address Proof */}
                                    <Box sx={{ flex: 1, minWidth: 280 }}>
                                      <Typography variant="subtitle1" sx={{ mb: 1 }}>
                                        Address Proof
                                      </Typography>

                                      {addressDocsRaw?.length > 0 ? (
                                        <DocumentPreview srcList={toPreviewUrls(addressDocsRaw)} />
                                      ) : (
                                        <Typography color="text.secondary">
                                          No address proof found
                                        </Typography>
                                      )}
                                    </Box>



                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          )}



                          {/* Building No */}
                          <Controller
                            name="building_no"
                            control={control}
                            rules={{ required: "Building No is required" }}
                            defaultValue={userFormvals.building_no || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Building No*"
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleChangeform(e);
                                }}
                              />
                            )}
                          />
                          <Controller
                            name="street"   // <-- use a valid form field name, not "Building No."
                            control={control}
                            rules={{ required: "Street is required" }}
                            defaultValue={userFormvals.street || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Street*"
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleChangeform(e);
                                }}
                              />
                            )}
                          />
                          {/* Country */}
                          <Box sx={addressLocationRowStyles}>
                            <Box sx={addressLocationLabelStyles}>
                              Country:
                            </Box>

                            <Box sx={addressLocationInputStyles}>
                              <Controller
                                name="country_code"
                                control={control}
                                render={({ field }) => (
                                  <>
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                      <Select
                                        {...field}
                                        value={countryCode}
                                        // onChange={(e) => {
                                        //   field.onChange(e);
                                        //   handleChangeform(e);
                                        //   if (e.target.value !== "QA") {
                                        //     setValue("customer_unique_id", "");
                                        //     setAddressData(prev => ({
                                        //       ...prev,
                                        //       customer_unique_id: "",
                                        //     }));
                                        //   }
                                        // }}
                                        onChange={(e) => {
                                          const value = e.target.value;

                                          field.onChange(value);
                                          handleCountry(value);

                                          if (value !== "QA") {
                                            setValue("customer_unique_id", "");

                                            setAddressData(prev => ({
                                              ...prev,
                                              customer_unique_id: "",
                                            }));
                                          }
                                        }}
                                        fullWidth
                                        sx={{ width: "100%" }}
                                      >
                                        {countryList.map((country) => (
                                          <MenuItem key={country.code} value={country.code}>
                                            {country.value}
                                          </MenuItem>
                                        ))}
                                      </Select>

                                      {countryCode === "QA" && (
                                        <Controller
                                          name="customer_unique_id"
                                          control={control}
                                          defaultValue={user?.customer_unique_id || ""}
                                          rules={{
                                            required: "Please enter Qatari ID",
                                            pattern: {
                                              value: /^\d{11}$/,
                                              message: "Qatari ID must be 11 digits",
                                            },
                                          }}

                                          render={({ field, fieldState: { error } }) => (
                                            <TextField
                                              {...field}
                                              label="Qatari ID (11-Digit)*"
                                              value={field.value ?? ""}
                                              error={!!error}
                                              helperText={error?.message}
                                              inputProps={{
                                                maxLength: 11,
                                                inputMode: "numeric",
                                              }}
                                              onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");

                                                field.onChange(value);

                                                handleChangeform({
                                                  target: {
                                                    name: "customer_unique_id",
                                                    value,
                                                  },
                                                });
                                              }}
                                              sx={{ width: "100%" }}
                                            />
                                         
                                          )}
                                        />

                                      )}
                                     
                                    </Box>
                                  </>
                                )}
                              />
                            </Box>
                          </Box>

                          {/* City */}
                          <Box
                            sx={addressLocationRowStyles}
                          >
                            <Box sx={addressLocationLabelStyles}>City:</Box>
                            <Box sx={addressLocationInputStyles}>
                              <Controller
                                name="city_id"
                                control={control}
                                rules={{ required: "City is required" }}
                                render={({ field, fieldState: { error } }) => (
                                  <>
                                    <Select
                                      {...field}
                                      value={field.value || ""}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleCityChange(e);
                                        setCitySearchEdit("");
                                        setDistrictSearchEdit("");
                                      }}
                                      sx={{ width: "100%", overflow: "visible" }}
                                      MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}
                                    >
                                      <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                                        <TextField
                                          autoFocus
                                          placeholder="Search city..."
                                          size="small"
                                          fullWidth
                                          value={citySearchEdit}
                                          onChange={(e) => setCitySearchEdit(e.target.value)}
                                          onKeyDown={(e) => e.stopPropagation()}
                                          onClick={(e) => e.stopPropagation()}
                                        />
                                      </MenuItem>
                                      {filteredCityListEdit.map((city) => (
                                        <MenuItem key={city.id} value={city.id}>
                                          {city.value}
                                        </MenuItem>
                                      ))}
                                      {!cityList.find((c) => c.id === "0") && (
                                        <MenuItem value="0">Others</MenuItem>
                                      )}
                                    </Select>
                                    {error && (
                                      <FormHelperText error>{error.message}</FormHelperText>
                                    )}
                                    {field.value === "0" && (
                                      <>
                                        <Box sx={{ width: "100%" }}>Other City*:</Box>
                                        <Controller
                                          name="other_city"
                                          control={control}
                                          rules={{ required: "Please specify the city" }}
                                          render={({ field, fieldState: { error } }) => (
                                            <TextField
                                              {...field}
                                              // label="Other City*"
                                              placeholder="Enter City Name"
                                              fullWidth
                                              sx={{ mt: 2 }}
                                              error={!!error}
                                              helperText={error?.message}
                                            />
                                          )}
                                        />
                                      </>

                                    )}
                                  </>
                                )}
                              />
                            </Box>
                          </Box>

                          {/* District */}
                          <Box
                            sx={addressLocationRowStyles}
                          >
                            <Box sx={addressLocationLabelStyles}>District:</Box>
                            <Box sx={addressLocationInputStyles}>
                              <Controller
                                name="district_id"
                                control={control}
                                rules={{ required: "District is required" }}
                                render={({ field, fieldState: { error } }) => (
                                  <>
                                    <Select
                                      {...field}
                                      value={field.value == null ? "" : String(field.value)}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        handleDistrictChange(e);
                                        setDistrictSearchEdit("");
                                      }}
                                      sx={{ width: "100%", overflow: "visible" }}
                                      MenuProps={{ autoFocus: false, disableAutoFocusItem: true, }}
                                    >
                                      <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                                        <TextField
                                          autoFocus
                                          placeholder="Search district..."
                                          size="small"
                                          fullWidth
                                          value={districtSearchEdit}
                                          onChange={(e) => setDistrictSearchEdit(e.target.value)}
                                          onKeyDown={(e) => e.stopPropagation()}
                                          onClick={(e) => e.stopPropagation()}
                                        />
                                      </MenuItem>
                                      {filteredDistrictListEdit.filter((district) => String(district.id) !== "0").map((district) => (
                                        <MenuItem key={district.id} value={String(district.id)}>
                                          {district.value}
                                        </MenuItem>
                                      ))}
                                      <MenuItem value="0">Others</MenuItem>
                                    </Select>
                                    {error && (
                                      <FormHelperText error>{error.message}</FormHelperText>
                                    )}
                                    {String(field.value) === "0" && (
                                      <>
                                        <Box sx={{ width: "100%" }}>Other District*:</Box>
                                        <Controller
                                          name="other_district"
                                          control={control}
                                          rules={{ required: "Please specify the district" }}
                                          render={({ field, fieldState: { error } }) => (
                                            <TextField
                                              {...field}
                                              // label="Other District*"
                                              placeholder="Enter District Name"
                                              fullWidth
                                              sx={{ mt: 2 }}
                                              error={!!error}
                                              helperText={error?.message}
                                            />
                                          )}
                                        />
                                      </>
                                    )}
                                  </>
                                )}
                              />
                            </Box>
                          </Box>



                          <Box sx={{ flex: 1 }}>

                            <Controller
                              name="contactPersonName"
                              control={control}
                              rules={{ required: "Contact Person Name is required" }}
                              defaultValue={userFormvals.contactPersonName || ""}
                              render={({ field, fieldState: { error } }) => (
                                <TextField
                                  {...field}
                                  label="Contact Person Name*"
                                  fullWidth
                                  sx={{ mb: 2 }}
                                  error={!!error}
                                  helperText={error?.message}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    handleChangeform(e);
                                  }}
                                />
                              )}
                            />
                          </Box>
                          {/* Postcode */}


                          <Controller
                            name="phone_ext"
                            control={control}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Country Phone Ext"
                                value={countryPhoneExt}
                                disabled
                                fullWidth
                              // sx={controllerFields}
                              />
                            )}
                          />

                          {/* Phone */}
                          <Controller
                            name="phone"
                            control={control}
                            rules={{
                              required: "Phone number is required",
                              pattern: {
                                value: /^[0-9]{8,15}$/,
                                message: "Enter a valid phone number (8–15 digits)",
                              },
                            }}
                            defaultValue={userFormvals.phone || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Phone Number*"
                                placeholder={phonePH}
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleChangeform(e);
                                }}
                              />
                            )}
                          />
                          <Controller
                            name="postcode"
                            control={control}
                            rules={{ required: "Postcode is required" }}
                            defaultValue={userFormvals.postcode || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField {...field}
                                inputProps={{
                                  maxLength: 10,
                                  pattern: "[0-9]*",
                                }}
                                label="Zip/Postal Code"
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                                onChange={(e) => {
                                  field.onChange(e);
                                  handleChangeform(e);
                                }} />
                            )}
                          />
                          {/* Email */}
                          <Controller
                            name="email"
                            control={control}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Enter a valid email address",
                              },
                            }}
                            defaultValue={userFormvals.email || ""}
                            render={({ field, fieldState: { error } }) => (
                              <TextField
                                {...field}
                                label="Email*"
                                fullWidth
                                sx={{ mb: 2 }}
                                error={!!error}
                                helperText={error?.message}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            )}
                          />

      {/* DOB */}
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name="dob"
          control={control}
          defaultValue={userFormvals.dob || null}
          rules={{
            required: "Date of Birth is required",
            validate: (value) =>
              dayjs(value).isBefore(dayjs(), "day") ||
              "Date of Birth cannot be in the future",
          }}
          render={({ field, fieldState: { error } }) => (
            <DesktopDatePicker
              label="Date of Birth*"
              inputFormat="MM/DD/YYYY"
              value={field.value}
              onChange={field.onChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{ mb: 2 }}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          )}
        />
      </LocalizationProvider> */}
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <Controller
    name="dob"
    control={control}
    defaultValue={
      userFormvals.dob ? dayjs(userFormvals.dob) : null // ✅ only prefill if dob exists
    }
    rules={{
      validate: (value) => {
        if (!value) return true; // ✅ allow blank DOB (not required)
        if (!dayjs(value).isValid()) return "Invalid date";
        if (dayjs(value).isAfter(dayjs(), "day"))
          return "Date of Birth cannot be in the future";
        return true;
      },
    }}
    render={({ field, fieldState: { error } }) => (
      <DesktopDatePicker
        label="Date of Birth"
        inputFormat="MM/DD/YYYY"
        value={field.value}
        onChange={(newValue) => field.onChange(newValue || null)} // ✅ null if cleared
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{ mb: 2 }}
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    )}
  />
</LocalizationProvider>

      {/* Gender & Welcome Email */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={6}>
          <Controller
            name="gender"
            control={control}
            rules={{ required: "Gender is required" }}
            render={({ field, fieldState: { error } }) => (
              <FormControl fullWidth error={!!error}>
                <InputLabel>Gender*</InputLabel>
                <Select {...field} label="Gender*">
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Grid>
        {/* <Grid item xs={6}>
          <Controller
            name="welcome_email"
            control={control}
            defaultValue={userFormvals.welcome_email || ""}
            render={({ field }) => (
              <TextField {...field} label="Welcome Email" fullWidth />
            )}
          />
        </Grid> */}
      </Grid>
    </React.Fragment>
  )}

  {currentGroup === 1 && (
    <React.Fragment>
      <Controller
        name="firstname"
        control={control}
        rules={{
          required: "First Name is required",
          pattern: {
            value: /^[\p{L}\p{M}\s'’-]+$/u,
            message: "Enter a valid English or Arabic name",
          },
        }}
        defaultValue={userFormvals.firstname || ""}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            label="First Name*"
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              field.onChange(e);
              handleChangeform(e);
            }}
          />
        )}
      />

      <Controller
        name="general_country_id"
        control={control}
        defaultValue=""
        rules={{ required: "Country is required" }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            value={field.value ?? ""}
            select
            label="Country*"
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              field.onChange(e);
                setGeneralCitySearch("");
                setGeneralDistrictSearch("");
                setValue("general_customer_unique_id", "", { shouldDirty: true });
                setValue("general_city_id", "", { shouldDirty: true });
                setValue("general_district_id", "", { shouldDirty: true });
                setValue("general_city", "", { shouldDirty: true });
                setValue("general_district", "", { shouldDirty: true });
            }}
          >
            {generalCountries.map(option => (
              <MenuItem key={option.id} value={String(option.id)}>{option.value}</MenuItem>
            ))}

          </TextField>
        )}
      />

      {generalCountry?.code === "QA" && (
        <Controller name="general_customer_unique_id" control={control} defaultValue="" shouldUnregister
          rules={{ required: "Please enter Qatari ID", pattern: { value: /^\d{11}$/, message: "Qatari ID must be 11 digits" } }}
          render={({ field, fieldState: { error } }) => (
            <TextField {...field} label="Qatari ID (11-Digit)*" sx={controllerFields}
              error={!!error} helperText={error?.message}
              inputProps={{ maxLength: 11, inputMode: "numeric" }}
              onChange={e => field.onChange(e.target.value.replace(/\D/g, ""))} />
          )}
        />
      )}

      <Controller
        name="general_city_id"
        control={control}
        defaultValue=""
        rules={{ required: "City is required" }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            value={field.value ?? ""}
            select
            SelectProps={{ MenuProps: { autoFocus: false, disableAutoFocusItem: true } }}
            label="City*"
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              field.onChange(e);
              setGeneralCitySearch("");
                setGeneralDistrictSearch("");
                setValue("general_district_id", "", { shouldDirty: true });
                setValue("general_city", "", { shouldDirty: true });
                setValue("general_district", "", { shouldDirty: true });
            }}
          >
            <MenuItem disableRipple onClick={e => e.stopPropagation()}>
              <TextField autoFocus placeholder="Search city..." size="small" fullWidth
                value={generalCitySearch} onChange={e => setGeneralCitySearch(e.target.value)}
                onKeyDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()} />
            </MenuItem>
            {generalCities.filter(option => option.value.toLowerCase().includes(generalCitySearch.toLowerCase())).map(option => (
              <MenuItem key={option.id} value={String(option.id)}>{option.value}</MenuItem>
            ))}
            {generalCountry && !generalCities.some(city => String(city.id) === "0") && (
              <MenuItem value="0">Others</MenuItem>
            )}

          </TextField>
        )}
      />

      {watch("general_city_id") === "0" && (
        <Controller
          name="general_city"
          control={control}
          defaultValue=""
          shouldUnregister
          rules={{ validate: value => !!value?.trim() || "Please enter a city name" }}
          render={({ field, fieldState: { error } }) => (
            <TextField {...field} label="Enter City Name*" sx={controllerFields}
              error={!!error} helperText={error?.message} />
          )}
        />
      )}

      <Controller
        name="general_district_id"
        control={control}
        defaultValue=""
        rules={{ required: "District is required" }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            value={field.value ?? ""}
            select
            SelectProps={{ MenuProps: { autoFocus: false, disableAutoFocusItem: true } }}
            label="District*"
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              field.onChange(e);
              setGeneralDistrictSearch("");
                setValue("general_district", "", { shouldDirty: true });
            }}
          >
            <MenuItem disableRipple onClick={e => e.stopPropagation()}>
              <TextField autoFocus placeholder="Search district..." size="small" fullWidth
                value={generalDistrictSearch} onChange={e => setGeneralDistrictSearch(e.target.value)}
                onKeyDown={e => e.stopPropagation()} onClick={e => e.stopPropagation()} />
            </MenuItem>
            {generalDistricts.filter(option => option.value.toLowerCase().includes(generalDistrictSearch.toLowerCase())).map(option => (
              <MenuItem key={option.id} value={String(option.id)}>{option.value}</MenuItem>
            ))}
            {watch("general_city_id") && <MenuItem value="0">Others</MenuItem>}
          </TextField>
        )}
      />

      {watch("general_district_id") === "0" && (
        <Controller
          name="general_district"
          control={control}
          defaultValue=""
          shouldUnregister
          rules={{ validate: value => !!value?.trim() || "Please enter a district name" }}
          render={({ field, fieldState: { error } }) => (
            <TextField {...field} label="Enter District Name*" sx={controllerFields}
              error={!!error} helperText={error?.message} />
          )}
        />
      )}

      <TextField
        label="Country Phone Ext"
        value={generalPhoneCountry?.text || ""}
        InputProps={{ readOnly: true }}
        sx={controllerFields}
      />

      <Controller
        name="mobile_number"
        control={control}
        rules={{
          required: "Mobile number is required",
          validate: value => {
            if (!generalPhoneCountry) return "Please select a valid country";
            return new RegExp(generalPhoneCountry.regEx).test(value || "") ||
              `Invalid phone number format. Expected: ${generalPhoneCountry.pHolder}`;
          },
        }}
        defaultValue={userFormvals.mobile_number || ""}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            label="Mobile Number*"
            placeholder={generalPhoneCountry?.pHolder}
            inputProps={{ maxLength: generalPhoneCountry?.length, inputMode: "numeric" }}
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            onChange={(e) => {
              field.onChange(e.target.value.replace(/\D/g, ""));
            }}
          />
        )}
      />

      <Controller
        name="email"
        control={control}
        rules={{
          required: "Email is required",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Enter valid email address",
          },
        }}
        defaultValue={user.email || ""}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            label="Email*"
            sx={controllerFields}
            error={!!error}
            helperText={error?.message}
            disabled
            onChange={(e) => {
              field.onChange(e);
              handleChangeform(e);
            }}
          />
        )}
      />

      <Controller
        name="gender"
        control={control}
        rules={{ required: "Gender is required" }}
        defaultValue={userFormvals.gender || ""}
        render={({ field, fieldState: { error } }) => (
          <>
            <InputLabel sx={{ ml: 21, mb: 0 }}>Gender*</InputLabel>
            <Select
              {...field}
              sx={controllerDropdowns}
              error={!!error}
              onChange={(e) => {
                field.onChange(e);
                handleChangeform(e);
              }}
            >
              <MenuItem value={1}>Male</MenuItem>
              <MenuItem value={2}>Female</MenuItem>
            </Select>
            {error && (
              <FormHelperText error sx={{ ml: 21 }}>
                {error.message}
              </FormHelperText>
            )}
          </>
        )}
      />

      {/* <Controller
        name="created_in"
        control={control}
        rules={{ required: "Language selection is required" }}
        defaultValue={userFormvals.created_in || ""}
        render={({ field, fieldState: { error } }) => (
          <>
            <InputLabel sx={{ ml: 21, mb: 0 }}>Send Welcome Email*</InputLabel>
            <Select
              {...field}
              sx={controllerDropdowns}
              error={!!error}
              onChange={(e) => {
                field.onChange(e);
                handleChangeform(e);
              }}
            >
              <MenuItem value="english">English</MenuItem>
              <MenuItem value="arabic">Arabic</MenuItem>
            </Select>
            {error && (
              <FormHelperText error sx={{ ml: 21 }}>
                {error.message}
              </FormHelperText>
            )}
          </>
        )}
      /> */}
    </React.Fragment>
  )}
</form>

</Box>
</React.Fragment>
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <AddressList email={user.email} userId={user.id} />
              </TabPanel>
              <TabPanel value={tabValue} index={3}>
                <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                  <Typography variant='h6'>Orders</Typography>
                  </Box>
                  { orderItem.length> 0 ?(<Box> {
                    (orderItem.length) ?
                    <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell align="center">Order ID</StyledTableCell>
                              <StyledTableCell align="center">Item Quantity</StyledTableCell>
                              <StyledTableCell align="center">Payment Method</StyledTableCell>
                              <StyledTableCell align="center">Status</StyledTableCell>
                              <StyledTableCell align="center">GrandTotal</StyledTableCell>
                              <StyledTableCell align="center">ADD Date</StyledTableCell>
                              <StyledTableCell align="center">Action</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                          {orderItem.map((data) => (
                              <StyledTableRow key={data.order_id  } >
                                <StyledTableCell component="th" scope="row">{data.order_id}</StyledTableCell>
                                <StyledTableCell align="center">{data.quantity}</StyledTableCell>
                                <StyledTableCell align="center">{data.payment_method.toUpperCase() === 'ONLINE' ? 'DEBIT/CREDIT CARD' : data.payment_method.toUpperCase()}</StyledTableCell>
                                <StyledTableCell align="center">{data.orderstatus}</StyledTableCell>
                                <StyledTableCell align="center">{parseFloat(data.grand_total).toFixed(2)}</StyledTableCell>
                                {/* <StyledTableCell align="center">{data.grand_total}</StyledTableCell> */}
                                <StyledTableCell align="center">{getModifiedDate(data['created_at'])}</StyledTableCell>
                                <Button onClick={() => handleOrderRedirect(data.order_id)}>VIEW</Button>
                                {/* <Button onClick >VIEW</Button> */}
                              </StyledTableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer> :
                      <Box></Box>
                    }
                </Box>):
               ( <Box>
                <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>Currently no orders to show</Typography> 
                </Box>
               )
              }
              
              <Box sx={{ justifyContent: 'center' }}>
              <Pagination count={Math.ceil(totalCount/10)} page={page} onChange={handleChangePage} />
              </Box>
              </TabPanel>
              
              <TabPanel value={tabValue} index={4}>
                <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                  <Typography variant='h6'>Shopping Cart</Typography>
                </Box>
                { cartItem.length> 0 ?(<Box> {
                isArray(cartItem) && cartItem.length > 0 ?
                    <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center">Product Name</StyledTableCell>
                          <StyledTableCell align="center">Item Quantity</StyledTableCell>
                          <StyledTableCell align="center">Price</StyledTableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {cartItem.map((data) => (
                          <StyledTableRow key={data.id} >
                            <StyledTableCell component="th" scope="row">
                              {data.name}
                            </StyledTableCell>
                            <StyledTableCell align="center">{data.qty}</StyledTableCell>
                            <StyledTableCell align="center">{data.price}</StyledTableCell>

                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer> :
                  <Box></Box>
                        }
                        </Box>
                ):
                  (<Box>
                  <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>Currently no item in your cart</Typography>
                </Box>
                  ) 
                }
              </TabPanel>
                  
                
              {/* <TabPanel value={tabValue} index={5}>
            Item -- Newsletter
          </TabPanel>
          <TabPanel value={tabValue} index={6}>
            Item -- Billing Agreements
          </TabPanel>
          <TabPanel value={tabValue} index={7}>
            Item -- Product Reviews
          </TabPanel> */}
              <TabPanel value={tabValue} index={5}>
                <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
                  <Typography variant='h6'>Wish List</Typography>
                </Box>
                <Box>
                  {
                    isArray(listData) && listData.length > 0 ?
                    <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center">Product Name</StyledTableCell>
                          {/* <StyledTableCell align="center">User Description</StyledTableCell> */}
                          <StyledTableCell align="center">Quantity</StyledTableCell>
                          <StyledTableCell align="center">Add Date</StyledTableCell>
                          <StyledTableCell align="center">Action</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {listData.map((item) => (
                          <StyledTableRow key={item.id} >
                            <StyledTableCell component="th" scope="row">
                              {item.name}
                            </StyledTableCell>
                            {/* <StyledTableCell align="center">{item.description}</StyledTableCell> */}
                            <StyledTableCell align="center">{item.qty}</StyledTableCell>
                            <StyledTableCell align="center">{item.added_at}</StyledTableCell>
                            <Button  onClick={()=>removeWishList(item.product_id)} >delete</Button>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer> :
                  <Box>
                    <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>No items added in wishlist</Typography>
                  </Box>
                  }
                </Box>
              </TabPanel>
            </Grid>
          </Grid>
        </Box>
      </Box>

    )
  }
}


export default EditUser